export default function ToastSystem({ toasts }) {
  return (
    <div style={{ position: "fixed", top: 24, right: 24, display: "flex", flexDirection: "column", gap: 8, zIndex: 9999 }}>
      {toasts.map((t) => (
        <div
          key={t.id}
          className="toast-enter"
          style={{
            padding: "12px 20px",
            borderRadius: 12,
            background: t.type === "success" ? "#0C6170" : t.type === "error" ? "#b91c1c" : "#37BEB0",
            color: "#fff",
            fontSize: 13.5,
            fontWeight: 600,
            fontFamily: "'Google Sans Flex',sans-serif",
            boxShadow: "0 8px 24px rgba(12,97,112,.25)",
            minWidth: 220,
            border: `1.5px solid ${t.type === "success" ? "#37BEB0" : t.type === "error" ? "#ef4444" : "#A4E5E0"}`,
          }}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
